// TikTok creative benchmark wire types (contract 27 §5/§6.1, v3 `CreativeBenchmarkSection.vue`).

/** Wire values — never translated (contract §13). */
export type BenchmarkDimension = 'LOCATION' | 'PLACEMENT' | 'AD_CATEGORY' | 'EXTERNAL_ACTION'

/** v3 `CreativeBenchmarkSection.vue:117–122` — the set that makes a request "not dirty". */
export const BENCHMARK_DEFAULT_DIMENSIONS: readonly BenchmarkDimension[] = [
  'LOCATION',
  'AD_CATEGORY',
  'EXTERNAL_ACTION',
  'PLACEMENT',
]

/** The only four compare windows the picker offers (v3 `:186–189`). */
export const BENCHMARK_PRESET_DAYS = { last7: 7, last14: 14, last30: 30, last60: 60 } as const
export type BenchmarkPreset = keyof typeof BENCHMARK_PRESET_DAYS
export type BenchmarkWindowDays = (typeof BENCHMARK_PRESET_DAYS)[BenchmarkPreset]

export interface BenchmarkRequest {
  dimensions: BenchmarkDimension[]
  compare_time_window: BenchmarkWindowDays
}

/** One benchmark record; `metrics` land on the report row prefixed `p_` (percentile). */
export interface BenchmarkRecord {
  info: { ad_id: string | number } & Record<string, unknown>
  metrics: Record<string, number>
}
